import 'highlight.js/styles/agate.css';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import './theme/uikit.scss';
import './theme/nprogress';
import './theme/nprogress.scss';
import './theme/multiselect.scss';

UIkit.use(Icons);



// WEBPACK FOOTER //
// ./theme.js